import { LogLevel } from '@/logger';

function parseLogLevel(data: unknown): LogLevel | undefined {
  const isValid = ((d): d is LogLevel => typeof data === 'string' && data in logger.levels)(data);

  return isValid ? data : undefined;
}

export default class DevConfig {
  logLevel?: LogLevel;

  constructor(obj: Record<string, unknown>) {
    this.logLevel = parseLogLevel(obj.logLevel);
  }

  apply() {
    const { logLevel } = this;

    logger.setLogLevel(logLevel ? logger.levels[logLevel] : undefined);
  }
}
